import React from 'react';
import styles from '../styles/Services.module.css';
import axios from 'axios';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const vehicleOptions = [
  {
    name: 'Audi Q3',
    descriptionKey: 'Premium SUV - Style & Comfort',
    imageUrl: 'https://images.hgmsites.net/med/2022-audi-q3-s-line-premium-45-tfsi-quattro-angular-front-exterior-view_100814289_m.jpg',
  },
  {
    name: 'Audi A6 Quattro',
    descriptionKey: 'Executive Luxury - Prestige & Performance',
    imageUrl: 'https://mediaservice.audi.com/media/fast/v3_xWTXWhbdRjG__6yrjY5SXpO7WnO2TGRnHNimcQl6dfijKy7mLsQVzZXwQ_iaXKSps0XyWnWsV3sRtYbQVEG4sQpVVCLThxDnTBHGUx0A_XCMRDqnUIV_GAVheHp3fu-PM_De_F71n4TfUsdwbMH1v4a-WfnvU9tIMRyW4jAK6LPW-rMte4RQswQrDWcqrtnoe1WRyxnMu0ue2mn196Ty-Qm085kvdZopaePTeSz6fGZTNqp16Oi3zeKgBD9p4XoO78dIyJDS5162-k4jYc7brfdanZrPVceLeWz-exYrlIez7pTY3NjpYlMKVOaKucrWSdXqUxOTZX35vbOzSl-xDUR8NOF0qyWSpVOq-mV3e6i12ov18XOSjPn5Ktix_ZTJJ_h_rcZfhn1KOoF1E_RQHsUfQD9EfTX0N9H_4zEByQuk_iO5G2Sf2IKzAXMP7DvkhojtYjYTzBM8EWCV5A6REPEThL7mF23MBYwnsNYweiS2If1KtZN7C1EDvkKyhDDZ1GzqPvRqxgaxijGIawA1m6s29ifEOwn-C7Sg0iPERlH9lCaKF-jPoS2iPYN2t_om5gDWFGsJFYRaxV7jNAhQneQLqLEUA6ivkd4jfDnhC8RvkPkHeR9yM8jO8jryDdRdqNMoBxGOY52GeNJjFMY68R_Ir5F_D_id0nsIDFI8jrJ3zFjmGcxPcwvsWaxtrAVbA37MPYG0irh84QvEv6VaIvoOQaPMXgBM0-sS-wNtFX0p9EvoX-BUSZ-lfg65ldIMtFb3FdleB71DOpVRq4TW8F-Afsc9g0fPkQ_4hQDGwQfJ3iEYJvgt4TmCJ0gdA1JQvqI8EuEfyASJmIQOU10mugK0bdQD6K9if4zu8oYH2J8T2KKxCyJHsl_MUeRp1GiaEfQTmBImDcwf0EKID1AZJPoJnIf8uuoJ1F_9Gk74zZ7NZ-yhtv0CjOdWs_x3OJsrV53igec0mK77u_d1PFa2ZsvZPO5TGrerVXnvUJ2fDyTcurteadQcepdN1VyGm7HKRz1_BYVp4vZYibjC5p-q7yaX4PCTKtb256e2LanGq7nlB3P6bmdrn8s5IYC07Mz_wOjDw2QrAMAAA?wid=1920',
  },
  {
    name: 'Opel Zafira Life (8 seats)',
    descriptionKey: 'Spacious & Ideal for Groups',
    imageUrl: 'https://cache4.arabwheels.ae/system/car_generation_pictures/30436/original/Cover.?1736816005',
  },
];

const Services = () => {
  const API = process.env.REACT_APP_API_URL;
  const { t } = useTranslation();
  const { lang } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      tripType: e.target.tripType.value,
      date: e.target.date.value,
      pickup: e.target.pickup.value,
      passengers: e.target.passengers.value,
      comments: e.target.comments.value
    };

    try {
      await axios.post(`${API}/api/booking`, formData);
      alert(t("book.alerts.success"));
      e.target.reset();
    } catch (err) {
      console.error(err);
      alert(t("book.alerts.error"));
    }
  };

  return (
    <>

      <section className={styles.quoteSection}>
        <div className={styles.container}>

          <h1 className={styles.title}>
            {t("book.title")}
          </h1>

          <p className={styles.subtitle}>
            {t("book.subtitle")}
          </p>

          <div className={styles.formCard}>
            <form className={styles.quoteForm} onSubmit={handleSubmit}>

              <h2 className={styles.sectionTitle}>
                {t("book.sections.contact")}
              </h2>

              <div className={styles.formGrid}>
                
                {/* LEFT */}
                <div className={styles.formColumn}>
                  <div className={styles.formGroup}>
                    <label htmlFor="name">{t("book.form.name")}</label>
                    <input type="text" id="name" name="name" required />
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="email">{t("book.form.email")}</label>
                    <input type="email" id="email" name="email" required />
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="phone">{t("book.form.phone")}</label>
                    <input type="tel" id="phone" name="phone" required />
                  </div>
                </div>

                {/* RIGHT */}
                <div className={styles.formColumn}>
                  <div className={styles.formGroup}>
                    <label htmlFor="tripType">{t("book.form.tripType")}</label>
                    <select id="tripType" name="tripType" required>
                      <option value="">{t("book.tripTypes.select")}</option>
                      <option value="airport">{t("book.tripTypes.airport")}</option>
                      <option value="port">{t("book.tripTypes.port")}</option>
                      <option value="city">{t("book.tripTypes.city")}</option>
                      <option value="tour">{t("book.tripTypes.tour")}</option>
                      <option value="other">{t("book.tripTypes.other")}</option>
                    </select>
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="date">{t("book.form.date")}</label>
                    <input
                      type="datetime-local"
                      id="date"
                      name="date"
                      min={new Date().toISOString().slice(0, 16)}
                      required
                    />
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="pickup">{t("book.form.pickup")}</label>
                    <input
                      type="text"
                      id="pickup"
                      name="pickup"
                      placeholder={t("book.form.pickup_placeholder")}
                      required
                    />
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="passengers">
                      {t("book.form.passengers")}
                    </label>
                    <input type="number" id="passengers" name="passengers" min="1" max="20" />
                  </div>
                </div>

              </div>

              <h2 className={styles.sectionTitle}>
                {t("book.sections.vehicles")}
              </h2>

              <div className={styles.vehiclesGrid}>
                {vehicleOptions.map((car, index) => (
                  <div key={index} className={styles.vehicleCard}>
                    <img src={car.imageUrl} alt={car.name} className={styles.vehicleImage} />
                    <h3 className={styles.vehicleName}>{car.name}</h3>
                    <p className={styles.vehicleDesc}>
                      {t(car.descriptionKey)}
                    </p>
                  </div>
                ))}
              </div>

              <h2 className={styles.sectionTitle}>
                {t("book.sections.requests")}
              </h2>

              <div className={styles.formGroup}>
                <textarea
                  id="comments"
                  name="comments"
                  rows="5"
                  placeholder={t("book.form.comments_placeholder")}
                />
              </div>

              <div className={styles.checkboxGroup}>
                <input type="checkbox" id="terms" name="terms" required />
                <label htmlFor="terms">
                  {t("book.terms.text")}{" "}
                  <a href={`/${lang}/terms`} target="_blank" rel='noreferrer'>
                    {t("book.terms.terms")}
                  </a>{" "}
                  {t("and")}{" "}
                  <a href={`/${lang}/privacy`} target="_blank" rel='noreferrer'>
                    {t("book.terms.privacy")}
                  </a>
                </label>
              </div>

              <button type="submit" className={styles.submitButton}>
                {t("book.form.submit")}
              </button>

            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;